"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class AssignmentBadRequestError extends client_library_1.ExtendableError {
}
exports.default = AssignmentBadRequestError;
//# sourceMappingURL=AssignmentBadRequestError.js.map